// Privacy-light analytics. track() fires first-party custom events to our worker
// (fire-and-forget, never throws); initWebAnalytics() injects the Cloudflare Web
// Analytics beacon only when a token is configured. No cookies, no PII.

const API_BASE = (import.meta.env.VITE_API_URL || 'http://localhost:8787').replace(/\/+$/, '');

/** Record a product event. Best-effort — analytics must never break the app. */
export function track(name: string, props?: Record<string, unknown>): void {
  try {
    const body = JSON.stringify({
      name,
      props,
      path: typeof location !== 'undefined' ? location.pathname : '',
    });
    fetch(`${API_BASE}/api/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => { /* ignore */ });
  } catch { /* ignore — never throw from analytics */ }
}

/** Inject the Cloudflare Web Analytics beacon, but only when a token is set
 *  (VITE_CF_BEACON_TOKEN, from the Cloudflare dashboard). Cookieless. */
export function initWebAnalytics(): void {
  const token = import.meta.env.VITE_CF_BEACON_TOKEN as string | undefined;
  if (!token || typeof document === 'undefined') return;
  const s = document.createElement('script');
  s.defer = true;
  s.src = 'https://static.cloudflareinsights.com/beacon.min.js';
  s.setAttribute('data-cf-beacon', JSON.stringify({ token }));
  document.head.appendChild(s);
}
